import React from 'react';
import {
  Router,
  browserHistory,
  applyRouterMiddleware,
  Route,
} from 'react-router';
import useRelay from 'react-router-relay';
import Relay from 'react-relay/classic';
import RegisterRoutes from './RegisterRoutes';
import ResetPasswordRoutes from './ResetPasswordRoutes';
import MainRoutes, { ParentRoute, PageLoading } from './MainRoutes';
import { getCurrencyClass } from './components/helpers/domainSettings';
import { scrollToTop } from './components/helpers/routerUtils';

class Root extends React.Component {
  render() {
    return (
      <div>
        <div id="router-wrapper" className={getCurrencyClass()}>
          <Router
            history={browserHistory}
            render={applyRouterMiddleware(useRelay)}
            environment={Relay.Store}
          >
            <Route
              path="m"
              component={ParentRoute}
              onChange={scrollToTop}
              render={(args) => PageLoading(ParentRoute, args)}
            >
              {RegisterRoutes}
              {ResetPasswordRoutes}
            </Route>
            {MainRoutes}
          </Router>
        </div>
      </div>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./js/Root.jsx